enum QueuedTasksTypes {
    SET_QUICK_REPLY_RICH_TEXT = 'SET_QUICK_REPLY_RICH_TEXT',
    SET_QUICK_REPLY_PLAIN_TEXT = 'SET_QUICK_REPLY_PLAIN_TEXT',
    UPDATE_ACW_ATTRIBUTES_QUEUED_TASKS = 'UPDATE_ACW_ATTRIBUTES_QUEUED_TASKS',
    CLEAR_ACW_ATTRIBUTES_QUEUED_TASKS = 'CLEAR_ACW_ATTRIBUTES_QUEUED_TASKS',
    SET_QUEUED_TASK_PROCESSING = 'SET_QUEUED_TASK_PROCESSING',
    SET_QUEUED_TASK_PROCESSING_SHOW_MODAL = 'SET_QUEUED_TASK_PROCESSING_SHOW_MODAL',
    SET_QUEUED_TASK_PROCESSING_CONTACTS = 'SET_QUEUED_TASK_PROCESSING_CONTACTS',
    SET_QUEUED_TASK_PROCESSING_STATUSES = 'SET_QUEUED_TASK_PROCESSING_STATUSES',
}

export default QueuedTasksTypes;